import type { MerchantRequest } from 'types/resolution';

const defectResolutionActions = [
  'AWAITING_RESOLUTION_RESPONSE', 'REVIEW_DEFECT_RESOLUTION', 'COMPLETE_EXTERNAL_RESOLUTION',
  'AWAITING_CUSTOMER_INFORMATION', 'COMPLETE_RETURN_INSPECTION',
];

export const requestHasRelevantSettlement = (request: Pick<MerchantRequest, 'type' | 'nextAction' | 'settlementType' | 'settlementStatus'>) =>
  Boolean((request.settlementType || request.settlementStatus) && !(request.type === 'RETURN' &&
    request.settlementStatus === 'MANUAL_ACTION_REQUIRED' && defectResolutionActions.includes(request.nextAction)));
